"use strict";

exports.__esModule = true;
var _CalendarContext = require("./CalendarContext");
Object.keys(_CalendarContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarContext[key]) return;
  exports[key] = _CalendarContext[key];
});